import styles from "./PaymentSuccess.module.scss";
import classNames from "classnames/bind";
import { CheckCircle } from "lucide-react";

const cx = classNames.bind(styles);

const PaymentSuccess = () => {
  return (
    <div className={cx("payment-success-container")}>
      <div className={cx("payment-success-content")}>
        <CheckCircle className={cx("success-icon")} />
        <h1 className={cx("success-title")}>Payment Successful</h1>
        <p className={cx("success-message")}>
          Your payment has been processed successfully.
        </p>
        <p className={cx("success-submessage")}>
          Thank you for your payment!
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
